const POPUP_SETTINGS = 'scrollbars=no,toolbar=no,location=no,titlebar=no,directories=no,status=no,menubar=no';

export function getPopupOffset({width, height}) {
    const wLeft = window.screenLeft ? window.screenLeft : window.screenX;
    const wTop = window.screenTop ? window.screenTop : window.screenY;

    const left = wLeft + (window.innerWidth / 2) - (width / 2);
    const top = wTop + (window.innerHeight / 2) - (height / 2);

    return {top, left};
}

// using kind allows for different popups later (as in for SSO)
export function getPopupSize(kind) {
    switch(kind){
        default:
            return {width: 580, height: 550};
    }
}

export function getPopupDimensions(kind) {
    const {width, height} = getPopupSize(kind);
    const {top, left} = getPopupOffset({width, height});

    return `width=${width},height=${height},top=${top},left=${left}`;
}

export function openPopup(url, name, kind) {
    const popup = window.open(url, name, `${POPUP_SETTINGS},${getPopupDimensions(kind)}`);
    const onUnloadHandler = function () {
        if (popup && !popup.closed) {
            popup.close();
        }
        window.removeEventListener('unload', onUnloadHandler);
    };
    window.addEventListener('unload', onUnloadHandler);
    return popup;
}

export function getLocationParams(location) {
    if (!location || !location.search) return {};
    const rawQueryString = location.search || '';
    const qs = rawQueryString.replace('?', '');
    const searchParams = new URLSearchParams(qs);
    return Object.fromEntries(searchParams.entries());
}

export function listenForCredentials(popup, resolve, reject) {
    if (!resolve) {
        return new Promise((res, rej) => {
            listenForCredentials(popup, res, rej);
        });
    } else {
        let creds;
        try {
            creds = getLocationParams(popup.location);
        } catch (e) {
            // Ignore CORS errors until the popup navigates back to our domain
        }

        if (creds && creds.token) {
            popup.close();
            resolve(creds);
        } else if (creds && creds.error) {
            popup.close();
            reject(new Error(creds.error));
        } else if (popup.closed) {
            reject(new Error('Popup closed before authentication finished.'));
        } else {
            setTimeout(() => {
                listenForCredentials(popup, resolve, reject);
            }, 200);
        }
    }
}
